import { ENGLISH_IQ_V2_STORAGE_KEY } from './english-iq-v2-storage-key';

export function clearEnglishIqV2StoredFlow(): void {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(ENGLISH_IQ_V2_STORAGE_KEY);
  }
}
